import React from 'react';
import { createView, view } from '@sail/ui';
import { helmTokens } from '../../theme';
export const Blocks = createView((props)=>{
    return /*#__PURE__*/ React.createElement(view.svg, {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement(view.path, {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.1762 3.36816L24.1762 7.52201C25.5928 8.17582 26.5 9.59364 26.5 11.1538V22.0352C26.5 23.5954 25.5928 25.0132 24.1762 25.667L15.1762 29.8209C14.1127 30.3118 12.8873 30.3118 11.8238 29.8209L2.82377 25.667C1.40717 25.0132 0.5 23.5954 0.5 22.0352V11.1538C0.5 10.5815 0.622072 10.0283 0.846584 9.52502L13.4997 15.3649V13.8229L1.64594 8.35114C1.9793 8.01154 2.3761 7.72863 2.82377 7.52201L11.8238 3.36816C12.8873 2.87728 14.1127 2.87728 15.1762 3.36816Z",
        css: {
            fill: `${helmTokens.color.blendBackground}`
        }
    }), /*#__PURE__*/ React.createElement(view.path, {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.5 17.1538V28.0352C39.5 29.5954 38.5928 31.0132 37.1762 31.667L28.1762 35.8209C27.1127 36.3118 25.8873 36.3118 24.8238 35.8209L15.8238 31.667C14.4072 31.0132 13.5 29.5954 13.5 28.0352V17.1538C13.5 16.5815 13.6221 16.0283 13.8466 15.525L26.5 21.3655L39.1534 15.525C39.3779 16.0283 39.5 16.5815 39.5 17.1538ZM28.1762 9.36816L37.1762 13.522C37.6239 13.7286 38.0207 14.0115 38.3541 14.3511L26.5 19.8236L14.645 14.3521C14.9785 14.0121 15.3757 13.7288 15.8238 13.522L24.8238 9.36816C25.8873 8.87728 27.1127 8.87728 28.1762 9.36816Z",
        css: {
            fill: `${helmTokens.color.blendForeground}`
        }
    }), /*#__PURE__*/ React.createElement(view.path, {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8466 15.525L26.5 21.3654V21.3645V22.0352C26.5 23.5954 25.5928 25.0132 24.1762 25.667L15.1762 29.8208C14.8314 29.98 14.4695 30.0876 14.1017 30.1435C13.7156 29.5226 13.5 28.7958 13.5 28.0352V17.1538C13.5 16.5815 13.6221 16.0283 13.8466 15.525ZM26.5 11.1538V19.8235L14.645 14.3521C14.9785 14.0121 15.3757 13.7288 15.8238 13.522L24.8238 9.36814C25.1686 9.20898 25.5305 9.10142 25.8983 9.04547C26.2844 9.66658 26.5 10.3933 26.5 11.1538Z",
        css: {
            fill: `${helmTokens.color.blendIntersection}`
        }
    }));
});

//# sourceMappingURL=Blocks.js.map